/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAttributeFilter } from '../models/CustomerAttributeFilter';
import type { ScheduledEventsResponse } from '../models/ScheduledEventsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MetricsSchedulersService {

    /**
     * Get scheduled events for universal dashboard metrics
     * Returns future scheduled events for the WX metrics dashboard
     * @param xAccessToken
     * @param teamTasks
     * @param openingIds
     * @param locationIds
     * @param brandIds
     * @param positionIds
     * @param openingAttributes Filter scheduled events by customer attributes attached to the funnel itself. Encoded as opening_attributes[][attribute_key]=K&opening_attributes[][attribute_values][]=v.
     * @param positionAttributes Filter scheduled events by customer attributes attached to the funnel's position.
     * @param locationAttributes Filter scheduled events by customer attributes attached to the funnel's location.
     * @returns ScheduledEventsResponse OK
     * @throws ApiError
     */
    public static getInternalApiWxMetricsSchedulers(
        xAccessToken: string,
        teamTasks?: boolean,
        openingIds?: Array<string>,
        locationIds?: Array<string>,
        brandIds?: Array<string>,
        positionIds?: Array<string>,
        openingAttributes?: Array<CustomerAttributeFilter>,
        positionAttributes?: Array<CustomerAttributeFilter>,
        locationAttributes?: Array<CustomerAttributeFilter>,
    ): CancelablePromise<ScheduledEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/metrics/schedulers',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'team_tasks': teamTasks,
                'opening_ids[]': openingIds,
                'location_ids[]': locationIds,
                'brand_ids[]': brandIds,
                'position_ids[]': positionIds,
                'opening_attributes[]': openingAttributes,
                'position_attributes[]': positionAttributes,
                'location_attributes[]': locationAttributes,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}